import React from 'react';

interface LabelWithErrorComponentProps extends React.HTMLAttributes<HTMLLabelElement> {
    inputId: string;
    showError: boolean;
    errorElement?: JSX.Element | null;
    children: JSX.Element | null;
}

function LabelWithErrorComponent({
    inputId,
    showError,
    errorElement,
    children,
    ...restProps
}: LabelWithErrorComponentProps): JSX.Element {
    return (
        <label htmlFor={inputId} className="c-text-input__label" {...restProps}>
            {children}
            {showError ? (
                <span className="c-veileder__feilmeldingsomrade">
                    <span className="error-icon"></span>
                    <span className="c-veileder__feilmelding">{errorElement}</span>
                </span>
            ) : null}
        </label>
    );
}

export default LabelWithErrorComponent;
